// Logica condivisa per la proposta "Visite da programmare".
// Regole: 1) visite scadute (data <= oggi) + future + riattivazioni;
//         2) un solo elemento per partner (dedup, priorità più alta / più in ritardo);
//         3) massimo 50 elementi per priorità.

const PRIO = { riattivazione: 0, partner_A: 1, partner_B: 2, partner_C: 3, partner_D: 4, partner_nc: 5, cliente: 6 };

const bucketKey = (it) => {
  if (it.riattivazione) return "riattivazione";
  if (it.is_partner === false) return "cliente";
  const c = it.partner_categoria;
  if (c && ["A", "B", "C", "D"].includes(c)) return `partner_${c}`;
  return "partner_nc";
};

const day = (d) => String(d || "").slice(0, 10);

export function buildDaProgrammare(reactItems, activities, opts = {}) {
  const perPriority = opts.perPriority ?? 50;
  const today = opts.today ?? new Date().toISOString().slice(0, 10);

  // Tutte le visite generate da programmare (scadute + future) + tutte le riattivazioni.
  const gen = (activities || []).filter(
    (it) => it.generated && it.status === "pianificato"
  );
  const all = [...(reactItems || []), ...gen];

  // Dedup per partner: tiene la priorità più alta e, a parità, la più in ritardo.
  const byPartner = new Map();
  for (const it of all) {
    const pid = it.partner_id || it.id;
    const prio = PRIO[bucketKey(it)] ?? 99;
    const ex = byPartner.get(pid);
    if (!ex) { byPartner.set(pid, it); continue; }
    const exPrio = PRIO[bucketKey(ex)] ?? 99;
    if (prio < exPrio) { byPartner.set(pid, it); continue; }
    if (prio === exPrio) {
      const a = day(it.date), b = day(ex.date);
      if (a < b || (a === b && (it.giorni || 0) > (ex.giorni || 0))) byPartner.set(pid, it);
    }
  }

  // Raggruppa per priorità, ordina per urgenza e limita a perPriority.
  const groups = {};
  for (const it of byPartner.values()) {
    const k = bucketKey(it);
    (groups[k] = groups[k] || []).push(it);
  }
  const out = [];
  for (const k of Object.keys(groups)) {
    const arr = groups[k].sort((a, b) =>
      k === "riattivazione" ? (b.giorni || 0) - (a.giorni || 0) : day(a.date).localeCompare(day(b.date))
    );
    out.push(...arr.slice(0, perPriority));
  }
  return out;
}
